import {
    changeEvent,
    customDocumentEvent,
    customEvent,
    dispatchCustomEvent, fireChangeEvent,
    inputEvent
} from "../../../../../../../webpack/modules/events";
import {isDesktop} from "../../../../../../../webpack/modules/devices";
import {updatePriceElements} from "../../../../../../../webpack/modules-optimized/product-list";
import {calculateCustomSizePrice, calculatePrice} from "../../../../../../../webpack/modules-optimized/product";
import {formatPrice} from "../../../../../../../webpack/modules-optimized/price";
import {hideElement, showElement, slideUp} from "../../../../../../../webpack/modules-optimized/element-visibility";

changeEvent('#product-list-page .product-configuration-size[data-option-type="selectable"] input[name="size"]', true, function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let previewElement = configurationMain.querySelector('.open-configuration .preview-option-size');
    let previewText = element.dataset.previewText;
    let label = element.closest('.size') || element.nextElementSibling;
    let optionSize = configurationMain.querySelector('input[name="option-size"]');
    let isCustomSize = element.value === 'custom-size';
    let customSizeCollapse = Collapse.getInstance(container.querySelector('#custom-size-body, #custom-both-size-body'));

    dispatchCustomEvent(
        'productSizeChanged',
        {
            'option': container,
            'container': container,
            'previewElement': previewElement,
            'previewText': previewText
        }
    );
    container.querySelectorAll('.size.selected').forEach((size) => size.classList.remove('selected'));
    label.classList.add('selected');
    optionSize.value = JSON.stringify(
        [
            {
                width: element.dataset.width,
                height: element.dataset.height,
                device: element.dataset.device,
                composition: element.dataset.composition,
                quantity: 1
            }
        ]
    )
    if (!isCustomSize) {
        resetCustomSizeForm();
        if (customSizeCollapse) customSizeCollapse.hide();
    }
    updatePriceElements(container);
    if ((element.dataset.width !== '' && element.dataset.height !== '') || element.dataset.device !== '' || element.dataset.composition !== ''){
        container.dataset.completed = 'true';
    } else {
        container.dataset.completed = 'false';
    }
    dispatchCustomEvent('productListProductConfigurationChanged');
});

customEvent('show.bs.collapse', '#product-list-page .product-configuration-size[data-option-type="selectable"] #custom-size-body, #product-list-page .product-configuration-size[data-option-type="selectable"] #custom-both-size-body', true, function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let previewElement = configurationMain.querySelector('.open-configuration .preview-size');
    let input = container.querySelector('input[name="size"][value="custom-size"]');
    let size = element.closest('.size');

    input.checked = true;
    dispatchCustomEvent(
        'productSizeChanged',
        {
            'option': container,
            'container': container,
            'previewElement': previewElement
        }
    );
    container.querySelectorAll('.size.selected').forEach((size) => size.classList.remove('selected'));
    size.classList.add('selected');
    if (input.dataset.width !== '' && input.dataset.height !== '') container.dataset.completed = 'true';
    else container.dataset.completed = 'false';
    dispatchCustomEvent('productListProductConfigurationChanged');
});

//SINGLE CUSTOM SIZE
let timeoutCustomSizeInputs = null;
inputEvent('#product-list-page .product-configuration-size[data-option-type="selectable"] input[name="custom-width"]', true, function(element) {
    let container = element.closest('.product-configuration');
    let productId = container.dataset.productId;
    let input = container.querySelector('input[name="size"][value="custom-size"]');
    let inputWidth = element;
    let inputHeight = container.querySelector('.custom-size-height');
    let errorElement = container.querySelector('.error-custom-sizes');

    input.dataset.width = '';
    input.dataset.height = '';

    clearTimeout(timeoutCustomSizeInputs);
    timeoutCustomSizeInputs = setTimeout(
        function() {
            dispatchCustomEvent(
                'calculateCustomHeight',
                {
                    'productId': productId,
                    'container': container,
                    'option': container,
                    'inputWidth': inputWidth,
                    'inputHeight': inputHeight,
                    'errorElement': errorElement,
                    'inputBlur': true
                }
            );
        },
        200
    );
});

//CUSTOM BOTH SIZE
let timeoutBothSizeInputs = null;
inputEvent('#product-list-page .product-configuration-size[data-option-type="selectable"] input[name="bothWidth"], #product-list-page .product-configuration-size[data-option-type="selectable"] input[name="bothHeight"]', true, function(element) {
    let container = element.closest('.product-configuration');
    let input = container.querySelector('input[name="size"][value="custom-size"]');
    let inputWidth = container.querySelector('input[name="bothWidth"]');
    let inputHeight = container.querySelector('input[name="bothHeight"]');
    let minSizeError = container.querySelector('.error-min-size');
    let maxSizeError = container.querySelector('.error-max-size');
    let errorWidth = container.querySelector('.error-width');
    let errorHeight = container.querySelector('.error-height');

    input.dataset.width = '';
    input.dataset.height = '';

    clearTimeout(timeoutBothSizeInputs);
    timeoutBothSizeInputs = setTimeout(
        function() {
            dispatchCustomEvent(
                'validateBothSize',
                {
                    'option': container,
                    'widthInput': inputWidth,
                    'heightInput': inputHeight,
                    'minSizeError': minSizeError,
                    'maxSizeError': maxSizeError,
                    'errorWidth': errorWidth,
                    'errorHeight': errorHeight
                }
            );
        },
        300
    );
});

customDocumentEvent('customHeightCalculated successValidateBothSize', async function() {
    if (!document.querySelector('.product-configuration-size[data-option-type="selectable"]') || document.querySelector('#modal-product')) return;
    let container = document.querySelector('#product-list-page .product-configuration-size[data-option-type="selectable"]');
    let mainContainer = isDesktop() ? container.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let productId = container.dataset.productId;
    let width = parseFloat(container.querySelector('input[name="custom-width"], input[name="bothWidth"]').value);
    let height = parseFloat(container.querySelector('.custom-size-height').innerHTML || container.querySelector('input[name="bothHeight"]').value);
    let pack = mainContainer.querySelector('input[name="option-pack"]');
    let color = mainContainer.querySelector('input[name="option-color"]');
    let supportColor = mainContainer.querySelector('input[name="option-supportColor"]');
    let headerPrice = container.querySelector('.custom-size button[data-bs-toggle="collapse"] .price');
    let bodyPrice = container.querySelector('.custom-size .collapse .custom-price .price');
    let size = container.querySelector('input[name="size"][value="custom-size"]');

    let responseCalculatePrice = await calculateCustomSizePrice(
        productId,
        width,
        height,
        pack ? pack.value : null,
        color ? color.value : null,
        supportColor ? supportColor.value : null
    );
    let price = responseCalculatePrice.price;
    price = formatPrice(price);

    headerPrice.innerHTML = price;
    bodyPrice.innerHTML = price;
    size.dataset.width = width;
    size.dataset.height = height;
    container.querySelectorAll('.custom-size .price-of').forEach((priceOf) => hideElement(priceOf));
    fireChangeEvent(size, true);
});

customDocumentEvent('customHeightErrorCalculate', function() {
    if (!document.querySelector('.product-configuration-size[data-option-type="selectable"]') || document.querySelector('#modal-product')) return;
    resetCustomSizeForm(false);
});

customDocumentEvent('errorValidateBothSize', function() {
    if (!document.querySelector('.product-configuration-size[data-option-type="selectable"]') || document.querySelector('#modal-product')) return;
    resetCustomSizeForm(false, false);
});

function resetCustomSizeForm(resetWidth = true, resetHeight = true)
{
    let container = document.querySelector('#product-list-page .product-configuration-size[data-option-type="selectable"]');

    if (!container.querySelector('.custom-size')) return;

    let headerPrice = container.querySelector('.custom-size button[data-bs-toggle="collapse"] .price');
    let bodyPrice = container.querySelector('.custom-size .collapse .custom-price .price');
    let size = container.querySelector('input[name="size"][value="custom-size"]');
    let widthInput = container.querySelector('input[name="custom-width"], input[name="bothWidth"]');
    let heightInput = container.querySelector('.custom-size-height, input[name="bothHeight"]');

    headerPrice.innerHTML = headerPrice.dataset.defaultValue;
    bodyPrice.innerHTML = bodyPrice.dataset.defaultValue;
    container.querySelectorAll('.custom-size .price-of').forEach((priceOf) => showElement(priceOf));
    size.dataset.width = '';
    size.dataset.height = '';
    if (resetWidth) widthInput.value = '';
    if (resetHeight) {
        heightInput.innerHTML = '';
        heightInput.value = '';
    }
}
